module.exports = __webpack_public_path__ + "img/1.290945ca.png";